import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VForm,
    {
      ref: "form",
      staticClass: "ns-credit-card-form",
      attrs: { "lazy-validation": "" },
    },
    [
      _c("h2", [
        _c("span", { staticClass: "title-small-bold" }, [
          _vm._v(_vm._s(_vm.t.formTitle)),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "secure" },
          [
            _c("NsIcon", { attrs: { "icon-name": "icon-lock" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.t.secure))]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(VTextField, {
        staticClass: "flex-column card-name",
        attrs: {
          name: "cardName",
          maxlength: "25",
          required: "",
          label: _vm.t.nameLabel,
          rules: _vm.rules,
        },
        on: { invalid: _vm.nameUpdated },
        model: {
          value: _vm.value.cardHolderName,
          callback: function ($$v) {
            _vm.$set(_vm.value, "cardHolderName", $$v)
          },
          expression: "value.cardHolderName",
        },
      }),
      _vm._v(" "),
      _c("NsCreditCard", {
        attrs: {
          "payment-type-id": _vm.value.paymentTypeId,
          "available-payments": _vm.paymentOptions,
          translations: _vm.t.creditCard,
          "field-disabled": _vm.editMode,
          "prevent-jcb-bin": _vm.preventJcbBin,
        },
        on: {
          input: _vm.updateCardNumber,
          paymentTypeId: _vm.updatePaymentTypeId,
        },
        model: {
          value: _vm.value.cardNumber,
          callback: function ($$v) {
            _vm.$set(_vm.value, "cardNumber", $$v)
          },
          expression: "value.cardNumber",
        },
      }),
      _vm._v(" "),
      _c("NsCreditCardDate", {
        ref: "creditCardDateForm",
        staticClass: "date-field",
        attrs: {
          translations: _vm.t.creditCardDate,
          "field-disabled": _vm.disableDate,
        },
        on: { input: _vm.updateCardDate },
        model: {
          value: _vm.cardDate,
          callback: function ($$v) {
            _vm.cardDate = $$v
          },
          expression: "cardDate",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }